var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTreeFolderClose = function SvgTreeFolderClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC700",
    stroke: "#222",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.333 6.5a1 1 0 0 1 1-1h6.084a1 1 0 0 1 .923.615l.737 1.77A1 1 0 0 0 13 8.5h7.333a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC700",
    stroke: "#222",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.333 11.5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1z"
  })));
};
export default SvgTreeFolderClose;